import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../utils/dialogOverlay.js";
import { uiState } from "../../state/uiState.js";
import {
	PASSWORD_FOCUS_TEXT,
	PASSWORD_PLACEHOLDER,
	getPasswordValidationMessage,
} from "../../utils/passwordPolicy.js";

const API = "/api";
const EMPTY_TEXT = "\u2014";
let didBind = false;

function ensureSifreDegistirDialog() {
	if (document.getElementById("sifreDegistirDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
<dialog id="sifreDegistirDialog">
    <form method="dialog" novalidate class="create-dialog-container">
        <div class="create-dialog-header">
            <h4>\u015eifremi De\u011fi\u015ftir</h4>
        </div>
        <div class="create-dialog-content">
            <div class="section">
                <div class="section-1-header"><h5>\u00dcye</h5></div>
                <div class="section-1-content">
                    <div class="info-card-yeni">
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">Ad Soyad</div>
                            <div class="info-card-yeni-deger sifre-degistir-adsoyad">${EMPTY_TEXT}</div>
                        </div>
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">Email</div>
                            <div class="info-card-yeni-deger sifre-degistir-email">${EMPTY_TEXT}</div>
                        </div>
                    </div>
                    <div class="column-container">
                        <label for="sifre_degistir_mevcut">Mevcut \u015eifre:</label>
                        <input id="sifre_degistir_mevcut" class="form-input" type="password" maxlength="100" placeholder="Mevcut \u015fifreniz" required autocomplete="current-password" data-asyncstate="idle" />
                        <span class="info" data-focus="L\u00fctfen mevcut \u015fifrenizi giriniz."></span>
                    </div>
                    <div class="column-container">
                        <label for="sifre_degistir_yeni">Yeni \u015eifre:</label>
                        <input id="sifre_degistir_yeni" class="form-input" type="password" maxlength="100" placeholder="${PASSWORD_PLACEHOLDER}" required autocomplete="new-password" />
                        <span class="info" data-focus="${PASSWORD_FOCUS_TEXT}"></span>
                    </div>
                    <div class="column-container">
                        <label for="sifre_degistir_tekrar">Yeni \u015eifre Tekrar:</label>
                        <input id="sifre_degistir_tekrar" class="form-input" type="password" maxlength="100" placeholder="Yeni \u015fifrenizi tekrar girin" required autocomplete="new-password" />
                        <span class="info" data-focus="L\u00fctfen yeni \u015fifrenizi tekrar giriniz."></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-dialog-buttons">
            <button type="button" class="sifre-degistir-cancel">\u0130ptal</button>
            <button type="submit" class="create-save">Kaydet</button>
        </div>
    </form>
</dialog>`);
}

export function initSifreDegistirDialog() {
	ensureSifreDegistirDialog();
	const dialog = document.querySelector("#sifreDegistirDialog");
	if (!dialog || didBind) return;
	didBind = true;

	const form = dialog.querySelector("form");
	const mevcutEl = dialog.querySelector("#sifre_degistir_mevcut");
	const yeniEl = dialog.querySelector("#sifre_degistir_yeni");
	const tekrarEl = dialog.querySelector("#sifre_degistir_tekrar");
	const cancelBtn = dialog.querySelector(".sifre-degistir-cancel");

	mevcutEl.setCustomValidity("pending");

	mevcutEl.addEventListener("input", () => {
		mevcutEl.dataset.asyncstate = "idle";
		mevcutEl.setCustomValidity("pending");
		mevcutEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
	});

	mevcutEl.addEventListener("blur", async () => {
		if (!mevcutEl.value) {
			mevcutEl.dataset.asyncstate = "idle";
			mevcutEl.setCustomValidity("pending");
			mevcutEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
			return;
		}

		mevcutEl.dataset.asyncstate = "loading";
		mevcutEl.setCustomValidity("pending");
		try {
			const res = await fetch(`${API}/uyeler/me/sifre/kontrol`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ sifre: mevcutEl.value }),
			});
			const data = await res.json();
			if (data.match) {
				mevcutEl.dataset.asyncstate = "valid";
				mevcutEl.setCustomValidity("");
				mevcutEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
			} else {
				mevcutEl.dataset.asyncstate = "invalid";
				mevcutEl.setCustomValidity("Mevcut \u015fifreniz yanl\u0131\u015f.");
				mevcutEl.parentElement.querySelector(".info")?.setAttribute("data-invalid", "Mevcut \u015fifreniz yanl\u0131\u015f.");
			}
		} catch {
			mevcutEl.dataset.asyncstate = "idle";
			mevcutEl.setCustomValidity("pending");
		}
	});

	function syncYeniValidity() {
		const infoSpan = yeniEl.parentElement.querySelector(".info");
		const errorText = getPasswordValidationMessage(yeniEl.value);
		if (errorText) {
			yeniEl.setCustomValidity(errorText);
			infoSpan?.setAttribute("data-invalid", errorText);
		} else {
			yeniEl.setCustomValidity("");
			infoSpan?.removeAttribute("data-invalid");
		}
		syncTekrarValidity();
	}

	function syncTekrarValidity() {
		const infoSpan = tekrarEl.parentElement.querySelector(".info");
		if (tekrarEl.value && tekrarEl.value !== yeniEl.value) {
			tekrarEl.setCustomValidity("\u015eifreler e\u015fle\u015fmiyor.");
			infoSpan?.setAttribute("data-invalid", "\u015eifreler e\u015fle\u015fmiyor.");
		} else {
			tekrarEl.setCustomValidity("");
			infoSpan?.removeAttribute("data-invalid");
		}
	}

	yeniEl.addEventListener("input", syncYeniValidity);
	yeniEl.addEventListener("blur", syncYeniValidity);
	tekrarEl.addEventListener("input", syncTekrarValidity);
	tekrarEl.addEventListener("blur", syncTekrarValidity);

	dialog.addEventListener("cancel", (e) => {
		if (dialog.dataset.forced === "true") e.preventDefault();
	});

	document.body.addEventListener("click", (e) => {
		if (e.target.closest(".sifre-degistir-cancel") && dialog.open) {
			if (dialog.dataset.forced !== "true") dialog.close();
		}
	});

	dialog.addEventListener("close", () => {
		form?.reset();
		delete dialog.dataset.submitted;
		mevcutEl.dataset.asyncstate = "idle";
		mevcutEl.setCustomValidity("pending");
		mevcutEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
		yeniEl.setCustomValidity("");
		tekrarEl.setCustomValidity("");
		yeniEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
		tekrarEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
		delete dialog.dataset.forced;
	});

	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		dialog.dataset.submitted = "true";

		if (!mevcutEl.value) {
			mevcutEl.dataset.asyncstate = "empty";
			mevcutEl.setCustomValidity("Mevcut \u015fifrenizi giriniz.");
			mevcutEl.parentElement.querySelector(".info")?.setAttribute("data-invalid", "Mevcut \u015fifrenizi giriniz.");
		}

		syncYeniValidity();
		syncTekrarValidity();

		if (!form.checkValidity()) {
			showToast("L\u00fctfen t\u00fcm alanlar\u0131 do\u011fru doldurunuz.", "error");
			return;
		}

		const mevcutSifre = mevcutEl.value;
		const yeniSifre = yeniEl.value;

		showDialogOverlay(dialog, "Kaydediliyor...");
		await new Promise((r) => setTimeout(r, 350));
		try {
			const res = await fetch(`${API}/uyeler/me/sifre`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ mevcutSifre, yeniSifre }),
			});
			const data = await res.json();
			if (!data.ok) {
				showToast(data.error || "\u015eifre g\u00fcncellenirken hata olu\u015ftu.", "error");
				return;
			}
			showToast("\u015eifre ba\u015far\u0131yla g\u00fcncellendi.", "success", false);
			dialog.close();
		} catch (err) {
			console.error("PATCH /uyeler/me/sifre hatasi:", err);
			showToast("Sunucuya ba\u011flan\u0131lamad\u0131.", "error");
		} finally {
			hideDialogOverlay();
		}
	});

	window.openSifreDegistirDialog = (forced = false) => {
		form?.reset();
		delete dialog.dataset.submitted;
		mevcutEl.dataset.asyncstate = "idle";
		mevcutEl.setCustomValidity("pending");
		mevcutEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
		yeniEl.setCustomValidity("");
		tekrarEl.setCustomValidity("");
		yeniEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");
		tekrarEl.parentElement.querySelector(".info")?.removeAttribute("data-invalid");

		const user = uiState.currentUser;
		dialog.querySelector(".sifre-degistir-adsoyad").textContent = user?.adSoyad || EMPTY_TEXT;
		dialog.querySelector(".sifre-degistir-email").textContent = user?.email || EMPTY_TEXT;

		if (forced) {
			dialog.dataset.forced = "true";
			cancelBtn.hidden = true;
		} else {
			delete dialog.dataset.forced;
			cancelBtn.hidden = false;
		}
		dialog.showModal();
	};
}

function showToast(message, type = "success", inDialog = true) {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		selector: inDialog ? document.querySelector("#sifreDegistirDialog") : document.body,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
		},
	}).showToast();
}
